import React from 'react';
import { Box } from '@mui/material';
import { Bot } from 'lucide-mui';
import { ToggleSetting, SettingsSection } from '../common';
import GoogleMeetIntegration from './GoogleMeet';

const MeetingBotSettings = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        bgcolor: 'transparent',
        px: 3,
        pt: 1,
        pb: 3,
        '& > *:not(:last-child)': {
          mb: 3,
        },
      }}
    >
      <SettingsSection title="Meeting Bot">
        <ToggleSetting
          checked={false}
          onChange={() => {}}
          label="Meeting Bot Recorder (Beta)"
          description="Connect your Google Calendar to automatically record and transcribe your Google Meet calls. Our bot will join your meetings, record the conversation, and provide you with searchable transcripts and AI summaries."
          icon={<Bot sx={{ width: 24, height: 24 }} />}
        >
          <Box sx={{ mt: 2 }}>
            <GoogleMeetIntegration />
          </Box>
        </ToggleSetting>
      </SettingsSection>
    </Box>
  );
};

export default MeetingBotSettings;
